import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export default function Footer() {
    return (
        <footer className="bg-navy-900 border-t border-white/10" data-testid="footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
                    <p className="text-gray-400 text-sm">
                        &copy; 2026 White Glove Hiring. All rights reserved.
                    </p>
                    <Link to="/privacy-policy" className="text-gray-400 hover:text-gold-400 transition-colors text-sm underline underline-offset-2" data-testid="footer-privacy-link">
                        Privacy Policy
                    </Link>
                    <Link to="/terms-of-service" className="text-gray-400 hover:text-gold-400 transition-colors text-sm underline underline-offset-2" data-testid="footer-terms-link">
                        Terms of Service
                    </Link>
                </div>
                <a href="mailto:adam@whiteglovehiring.com" className="flex items-center gap-2 text-gray-400 hover:text-gold-400 transition-colors text-sm" data-testid="footer-email">
                    <Mail size={14} />
                    adam@whiteglovehiring.com
                </a>
            </div>
        </footer>
    );
}
